import hexToRgba from "hex-to-rgba";
import { vectorType, vectorTileType } from '../../interface-type'

export const defaultStyle = {
  point: {
    symbol: "circle",
    radius: 6,
    fill_color: "#00bfff",
    fill_opacity: 0.4,
    stroke_color: "#fff",
    stroke_width: 2,
    classify: false,
    clList: []
  },
  linestring: {
    stroke_color: "#00bfff",
    stroke_width: 2,
    classify: false,
    clList: []
  },
  polygon: {
    fill_color: "#00bfff",
    fill_opacity: 0.4,
    stroke_color: "#00bfff",
    stroke_width: 1.3,
    classify: false,
    clList: []
  }
};

const genPoint = (
  type: string,
  id: string,
  style: any,
  sourceLayer: string | number | null
) => {
  if (style.classify && style.clList.length > 0) {
    const classifyList = style.clList
    return classifyList.map((cls: any, index: number) => type === 'vectorTile' ? {
      id: `${type}Layer-${id}-point-classify-${index}`,
      type: cls.symbol,
      source: `${type}Source-${id}`,
      "source-layer": String(sourceLayer),
      paint: {
        "circle-radius": cls.radius,
        "circle-color":
          cls.fill_color.length > 7
            ? cls.fill_color.substring(0, 7).toLowerCase()
            : cls.fill_color.toLowerCase(),
        "circle-opacity": cls.fill_opacity ? cls.fill_opacity : 1,
        "circle-stroke-color":
          cls.stroke_color.length > 7
            ? cls.stroke_color.substring(0, 7).toLowerCase()
            : cls.stroke_color.toLowerCase(),
        "circle-stroke-width": cls.stroke_width ? cls.stroke_width : 1
      },
      filter: ["all", ["==", "$type", "Point"], ...cls.filter]
    } : {
        id: `${type}Layer-${id}-point-`,
        type: cls.symbol,
        source: `${type}Source-${id}`,
        paint: {
          "circle-radius": cls.radius,
          "circle-color":
            cls.fill_color.length > 7
              ? cls.fill_color.substring(0, 7).toLowerCase()
              : cls.fill_color.toLowerCase(),
          "circle-opacity": cls.fill_opacity,
          "circle-stroke-color":
            cls.stroke_color.length > 7
              ? cls.stroke_color.substring(0, 7).toLowerCase()
              : cls.stroke_color.toLowerCase(),
          "circle-stroke-width": cls.stroke_width
        },
        filter: ["all", ["==", "$type", "Point"], ...cls.filter]
      })
    // return new Array();
  } else {
    return type === "vectorTile"
      ? [
        {
          id: `${type}Layer-${id}-point`,
          type: style.symbol,
          source: `${type}Source-${id}`,
          "source-layer": String(sourceLayer),
          paint: {
            "circle-radius": style.radius,
            "circle-color":
              style.fill_color.length > 7
                ? style.fill_color.substring(0, 7).toLowerCase()
                : style.fill_color.toLowerCase(),
            "circle-opacity": style.fill_opacity ? style.fill_opacity : 1,
            "circle-stroke-color":
              style.stroke_color.length > 7
                ? style.stroke_color.substring(0, 7).toLowerCase()
                : style.stroke_color.toLowerCase(),
            "circle-stroke-width": style.stroke_width ? style.stroke_width : 1
          },
          filter: ["==", "$type", "Point"]
        }
      ]
      : type === 'vector' ? [
        {
          id: `${type}Layer-${id}-point`,
          type: style.symbol,
          source: `${type}Source-${id}`,
          paint: {
            "circle-radius": style.radius,
            "circle-color":
              style.fill_color.length > 7
                ? style.fill_color.substring(0, 7).toLowerCase()
                : style.fill_color.toLowerCase(),
            "circle-opacity": style.fill_opacity,
            "circle-stroke-color":
              style.stroke_color.length > 7
                ? style.stroke_color.substring(0, 7).toLowerCase()
                : style.stroke_color.toLowerCase(),
            "circle-stroke-width": style.stroke_width
          },
          filter: ["==", "$type", "Point"]
        }
      ] : [
          {
            id: `${id}`,
            type: style.symbol,
            source: `${id}`,
            paint: {
              "circle-radius": style.radius,
              "circle-color":
                style.fill_color.length > 7
                  ? style.fill_color.substring(0, 7).toLowerCase()
                  : style.fill_color.toLowerCase(),
              "circle-opacity": style.fill_opacity,
              "circle-stroke-color":
                style.stroke_color.length > 7
                  ? style.stroke_color.substring(0, 7).toLowerCase()
                  : style.stroke_color.toLowerCase(),
              "circle-stroke-width": style.stroke_width
            },
            filter: ["==", "$type", "Point"]
          }
        ];
  }
};

const genLineString = (
  type: string,
  id: string,
  style: any,
  sourceLayer: string | number | null
) => {
  if (style.classify && style.clList.length > 0) {
    return style.clList.map((s: any) => {
      if (type === "vectorTile") {
        const layers = {
          id: `${type}Layer-${id}-${s.filter[0][1]}-${s.filter[0][2]}-linestring`,
          type: "line",
          source: `${type}Source-${id}`,
          "source-layer": String(sourceLayer),
          paint: {
            "line-color":
              s.stroke_color.length > 7
                ? s.stroke_color.substring(0, 7).toLowerCase()
                : s.stroke_color.toLowerCase(),
            "line-width": s.stroke_width ? s.stroke_width : 1,
            "line-opacity":
              s.stroke_opacity && s.stroke_opacity.length <= 7
                ? s.stroke_opacity
                : !s.stroke_opacity && s.stroke_color.length > 7
                  ? Number(
                    hexToRgba(s.stroke_color)
                      .substring(5, hexToRgba(s.stroke_color).length - 1)
                      .split(", ")[3]
                  )
                  : 1
          },
          filter: ["all", ["==", "$type", "LineString"], ...s.filter]
        };
        return layers
      } else {
        const layers = {
          id: `${type}Layer-${id}-${s.filter[0][1]}-${s.filter[0][2]}-linestring`,
          type: "line",
          source: `${type}Source-${id}`,
          paint: {
            "line-color":
              s.stroke_color.length > 7
                ? s.stroke_color.substring(0, 7).toLowerCase()
                : s.stroke_color.toLowerCase(),
            "line-width": s.stroke_width,
            "line-opacity":
              s.stroke_opacity && s.stroke_opacity.length <= 7
                ? s.stroke_opacity
                : !s.stroke_opacity && s.stroke_color.length > 7
                  ? Number(
                    hexToRgba(s.stroke_color)
                      .substring(5, hexToRgba(s.stroke_color).length - 1)
                      .split(", ")[3]
                  )
                  : 1
          },
          filter: ["all", ["==", "$type", "LineString"], ...s.filter]
        };
        return layers
      }
    });
  } else {
    return type === "vectorTile"
      ? [
        {
          id: `${type}Layer-${id}-linestring`,
          type: "line",
          source: `${type}Source-${id}`,
          "source-layer": String(sourceLayer),
          paint: {
            "line-color":
              style.stroke_color.length > 7
                ? style.stroke_color.substring(0, 7).toLowerCase()
                : style.stroke_color.toLowerCase(),
            "line-width": style.stroke_width ? style.stroke_width : 1,
            "line-opacity": style.stroke_opacity ? style.stroke_opacity : 1
          },
          filter: ["==", "$type", "LineString"]
        }
      ]
      : [
        {
          id: `${type}Layer-${id}-linestring`,
          type: "line",
          source: `${type}Source-${id}`,
          paint: {
            "line-color":
              style.stroke_color.length > 7
                ? style.stroke_color.substring(0, 7).toLowerCase()
                : style.stroke_color.toLowerCase(),
            "line-width": style.stroke_width ? style.stroke_width : 1,
            "line-opacity": style.stroke_opacity ? style.stroke_opacity : 1
          },
          filter: ["==", "$type", "LineString"]
        }
      ];
  }
};

const genPolygon = (
  type: string,
  id: string,
  style: any,
  sourceLayer: string | number | null
) => {
  if (style.classify && style.clList.length > 0) {
    let arrayLayers = new Array();
    style.clList.map((s: any) => {
      if (type === "vectorTile") {
        const layers = [
          {
            id: `${type}Layer-${id}-${s.filter[0][1]}-${s.filter[0][2]}-polygon`,
            type: "fill",
            source: `${type}Source-${id}`,
            "source-layer": String(sourceLayer),
            paint: {
              "fill-color":
                s.fill_color.length > 7
                  ? s.fill_color.substring(0, 7).toLowerCase()
                  : s.fill_color.toLowerCase(),
              "fill-opacity":
                s.fill_opacity && s.fill_color.length <= 7
                  ? s.fill_opacity
                  : !s.fill_opacity && s.fill_color.length > 7
                    ? Number(
                      hexToRgba(s.fill_color)
                        .substring(5, hexToRgba(s.fill_color).length - 1)
                        .split(", ")[3]
                    )
                    : 1
            },
            filter: ["all", ["==", "$type", "Polygon"], ...s.filter]
          },
          {
            id: `${type}Layer-${id}-${s.filter[0][1]}-${s.filter[0][2]}-polygon-outline`,
            type: "line",
            source: `${type}Source-${id}`,
            "source-layer": String(sourceLayer),
            paint: {
              "line-color":
                s.stroke_color.length > 7
                  ? s.stroke_color.substring(0, 7).toLowerCase()
                  : s.stroke_color.toLowerCase(),
              "line-width": s.stroke_width,
              "line-opacity":
                s.stroke_opacity && s.stroke_opacity.length <= 7
                  ? s.stroke_opacity
                  : !s.stroke_opacity && s.stroke_color.length > 7
                    ? Number(
                      hexToRgba(s.stroke_color)
                        .substring(5, hexToRgba(s.stroke_color).length - 1)
                        .split(", ")[3]
                    )
                    : 1
            },
            filter: ["all", ["==", "$type", "Polygon"], ...s.filter]
          }
        ];
        arrayLayers.push(layers[0]);
        arrayLayers.push(layers[1]);
      } else {
        const layers = [
          {
            id: `${type}Layer-${id}-${s.display_name}-polygon`,
            type: "fill",
            source: `${type}Source-${id}`,
            paint: {
              "fill-color":
                s.fill_color.length > 7
                  ? s.fill_color.substring(0, 7).toLowerCase()
                  : s.fill_color.toLowerCase(),
              "fill-opacity": s.fill_opacity ? s.fill_opacity : 1
            },
            filter: ["any", ["==", "$type", "Polygon"], s.filter]
          },
          {
            id: `${type}Layer-${id}-${s.display_name}-polygon-outline`,
            type: "line",
            source: `${type}Source-${id}`,
            paint: {
              "line-color":
                style.stroke_color.length > 7
                  ? style.stroke_color.substring(0, 7).toLowerCase()
                  : style.stroke_color.toLowerCase(),
              "line-width": style.stroke_width
            },
            filter: ["any", ["==", "$type", "Polygon"], s.filter]
          }
        ];
        arrayLayers.push(layers[0]);
        arrayLayers.push(layers[1]);
      }
      return false;
    });
    return arrayLayers;
  } else {
    return type === "vectorTile"
      ? [
        {
          id: `${type}Layer-${id}-polygon`,
          type: "fill",
          source: `${type}Source-${id}`,
          "source-layer": String(sourceLayer),
          paint: {
            "fill-color":
              style.fill_color.length > 7
                ? style.fill_color.substring(0, 7).toLowerCase()
                : style.fill_color.toLowerCase(),
            "fill-opacity":
              style.fill_opacity && style.fill_color.length <= 7
                ? style.fill_opacity
                : !style.fill_opacity && style.fill_color.length > 7
                  ? Number(
                    hexToRgba(style.fill_color)
                      .substring(5, hexToRgba(style.fill_color).length - 1)
                      .split(", ")[3]
                  )
                  : 1
          },
          filter: ["==", "$type", "Polygon"]
        },
        {
          id: `${type}Layer-${id}-polygon-outline`,
          type: "line",
          source: `${type}Source-${id}`,
          "source-layer": String(sourceLayer),
          paint: {
            "line-color":
              style.stroke_color.length > 7
                ? style.stroke_color.substring(0, 7).toLowerCase()
                : style.stroke_color.toLowerCase(),
            "line-width": style.stroke_width,
            "line-opacity":
              style.stroke_opacity && style.stroke_opacity.length <= 7
                ? style.stroke_opacity
                : !style.stroke_opacity && style.stroke_color.length > 7
                  ? Number(
                    hexToRgba(style.stroke_color)
                      .substring(5, hexToRgba(style.stroke_color).length - 1)
                      .split(", ")[3]
                  )
                  : 1
          },
          filter: ["==", "$type", "Polygon"]
        }
      ]
      : [
        {
          id: `${type}Layer-${id}-polygon`,
          type: "fill",
          source: `${type}Source-${id}`,
          paint: {
            "fill-color":
              style.fill_color.length > 7
                ? style.fill_color.substring(0, 7).toLowerCase()
                : style.fill_color.toLowerCase(),
            "fill-opacity":
              style.fill_opacity && style.fill_color.length <= 7
                ? style.fill_opacity
                : !style.fill_opacity && style.fill_color.length > 7
                  ? Number(
                    hexToRgba(style.fill_color)
                      .substring(5, hexToRgba(style.fill_color).length - 1)
                      .split(", ")[3]
                  )
                  : 1
          },
          filter: ["==", "$type", "Polygon"]
        },
        {
          id: `${type}Layer-${id}-polygon-outline`,
          type: "line",
          source: `${type}Source-${id}`,
          paint: {
            "line-color":
              style.stroke_color.length > 7
                ? style.stroke_color.substring(0, 7).toLowerCase()
                : style.stroke_color.toLowerCase(),
            "line-width": style.stroke_width,
            "line-opacity":
              style.stroke_opacity && style.stroke_opacity.length <= 7
                ? style.stroke_opacity
                : !style.stroke_opacity && style.stroke_color.length > 7
                  ? Number(
                    hexToRgba(style.stroke_color)
                      .substring(5, hexToRgba(style.stroke_color).length - 1)
                      .split(", ")[3]
                  )
                  : 1
          },
          filter: ["==", "$type", "Polygon"]
        }
      ];
  }
};

export const jetStreamVectorToMapboxStyle = (vector: vectorType) => {
  const outputSource = {
    id: vector.id,
    data: { type: "geojson", data: vector.data }
  };
  const pointGroupLayer = genPoint(
    "jetstreamVector",
    vector.id,
    vector.style ? vector.style.point : defaultStyle.point,
    null
  );

  const outputLayers = [
    ...pointGroupLayer
  ];
  return { source: outputSource, layers: outputLayers };
};

export const vectorToMapboxStyle = (vector: vectorType) => {
  const outputSource = {
    id: `vectorSource-${vector.id}`,
    data: { type: "geojson", data: vector.data }
  };
  const pointGroupLayer = genPoint(
    "vector",
    vector.id,
    vector.style ? vector.style.point : defaultStyle.point,
    null
  );
  const lineStringGroupLayer = genLineString(
    "vector",
    vector.id,
    vector.style ? vector.style.linestring : defaultStyle.linestring,
    null
  );
  const polygonGroupLayer = genPolygon(
    "vector",
    vector.id,
    vector.style ? vector.style.polygon : defaultStyle.polygon,
    null
  );

  const outputLayers = [
    ...polygonGroupLayer,
    ...lineStringGroupLayer,
    ...pointGroupLayer
  ];
  return { source: outputSource, layers: outputLayers };
};

export const vectorTileToMapboxStyle = (vectorTile: vectorTileType) => {
  const outputSource = {
    id: `vectorTileSource-${vectorTile.id}`,
    data: { type: "vector", tiles: vectorTile.url, maxzoom: 14 }
  };
  const pointGroupLayer = genPoint(
    "vectorTile",
    vectorTile.id,
    vectorTile.style ? vectorTile.style.point : defaultStyle.point,
    vectorTile.sourceLayer
  );
  const lineStringGroupLayer = genLineString(
    "vectorTile",
    vectorTile.id,
    vectorTile.style ? vectorTile.style.linestring : defaultStyle.linestring,
    vectorTile.sourceLayer
  );
  const polygonGroupLayer = genPolygon(
    "vectorTile",
    vectorTile.id,
    vectorTile.style ? vectorTile.style.polygon : defaultStyle.polygon,
    vectorTile.sourceLayer
  );

  const outputLayers = [
    ...polygonGroupLayer,
    ...lineStringGroupLayer,
    ...pointGroupLayer
  ];
  return { source: outputSource, layers: outputLayers };
};
